import { useState } from 'react';
import Button from '@mui/material/Button';
import { List } from './list';
import Modal from '@/components/common/modal';
import Box from '@mui/material/Box';
import CreateForm from '@/components/organizations/user-organizations/create.form';
import { Divider } from '@mui/material';
import { useTranslations } from '@/i18n/use-translations';
import { useFeatureAccess } from '@/hooks/use-feature-access';

export default function SwitchModal({
  open,
  close,
}: {
  open: boolean;
  close: React.Dispatch<React.SetStateAction<void>>;
}) {
  const t = useTranslations();
  const [showForm, setShowForm] = useState(false);
  // Check feature flag for organization creation - allows gradual rollout
  const { hasAccess: hasCreateOrganizationPermission } = useFeatureAccess('create-organization');

  const handleClose = () => {
    close();
    setShowForm(false);
  };

  const handleFormCancel = () => {
    setShowForm(false);
  };

  return (
    <Modal
      open={open}
      handleClose={handleClose}
      title={showForm ? t('organization.createNewTitle') : t('organization.switchTitle')}
      description={showForm ? t('organization.createNewDescription') : t('organization.switchDescription')}
    >
      {showForm ? (
        <CreateForm onCancel={handleFormCancel} onSuccess={handleClose} />
      ) : (
        <>
          <List close={handleClose} />
          <Divider sx={{ my: 1 }} />
          <Box sx={{ display: 'flex', mt: 1, gap: 2, justifyContent: 'end' }}>
            <Button variant="outlined" size="small" onClick={handleClose}>
              {t('common.cancel')}
            </Button>
            {hasCreateOrganizationPermission && (
              <Button variant="outlined" size="small" onClick={() => setShowForm(true)}>
                {t('common.createNew')}
              </Button>
            )}
          </Box>
        </>
      )}
    </Modal>
  );
}
